import { getFirestore } from 'firebase/firestore'
import { getFunctions, httpsCallable } from '@firebase/functions'

export const useGetFirestore = () => {
  const config = useRuntimeConfig()
  return getFirestore(config.public.FIRESTORE_DATABASE_ID as string)
}

export const useHttpsCallable = async <
  RequestData = unknown,
  ResponseData = unknown,
>(
  functionName: string,
  data?: RequestData,
): Promise<ResponseData | undefined> => {
  // const nuxtApp = useNuxtApp();
  // const toast = nuxtApp.vueApp.config.globalProperties.$toast;

  try {
    const functions = getFunctions()
    const httpsCallableFunction = httpsCallable<RequestData, ResponseData>(
      functions,
      functionName,
    )
    return (await httpsCallableFunction(data)) as ResponseData
  }
  catch (detail) {
    /* toast.add({
      severity: "error",
      summary: "Error Message",
      detail,
      life: 5000,
    }); */
    throw new Error(detail as string)
  }
}
